import React from "react";
import { useParams } from "react-router-dom";
import { Box, useTheme } from "@material-ui/core";
import { VulnerabilitiesChip } from "../../features/CustomerVulnerabilities";
import { BackButton } from "../BackButton";
import { Breadcrumbs } from "../Breadcrumb";
import { WrapUpNotesButton } from "../WrapUpNotesButton";
import { AccountStatusChip } from "../AccountStatus";
import { useAccount } from "../../api/hooks";
import { ACCOUNT_HEADER_PORTAL_ID } from "./AccountHeaderTitle";

export const AccountHeader: React.FC = ({ children, ...props }) => {
  const theme = useTheme();
  const { accountNumber } = useParams();
  const { data: account } = useAccount(accountNumber);

  return (
    <>
      {/* AccountHeader */}
      <Box
        data-testid="AccountHeader"
        {...props}
        component="header"
        display="flex"
        flexWrap="wrap"
        width={1}
        p={3}
        bgcolor="background.paper"
        borderBottom={`1px solid ${theme.palette.divider}`}
      >
        {/* Top Row */}
        <Box width={1} mb={1} display="flex" alignItems="center">
          <BackButton mr={1} />
          <Breadcrumbs />
        </Box>

        {/* Bottom Row */}
        <Box width={1} display="flex" alignItems="center">
          <Box
            display="flex"
            flexGrow={1}
            flexWrap="wrap"
            alignItems={["flex-start", "center"]}
            flexDirection={["column", "row"]}
          >
            {/* Page Title, use the AccountHeaderTitle component to set */}
            <Box
              id={ACCOUNT_HEADER_PORTAL_ID} // this is the hook for the AccountHeaderTitle portal!
              data-testid="AccountHeader__Title"
              display="flex"
              alignItems="center"
              mr={2}
            />

            {/* Chips */}
            <Box flexGrow={1}>
              <VulnerabilitiesChip accountNumber={accountNumber} />
              {account?.status && <AccountStatusChip status={account.status} />}
            </Box>
          </Box>

          {/* Action Button Container */}
          <Box data-testid="AccountHeader__Actions" flexShrink={0}>
            <WrapUpNotesButton />
          </Box>
        </Box>
      </Box>
    </>
  );
};
